const SortieLocations = {
  overEngland: 'Over England',
  overFrance: 'Over France',
  overTheSea: 'Over the Channel',
};
export default SortieLocations;
